import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/main.tsx';
import tripRepository from '@/api/repositories/tripRepository/TripRepository.ts';
import type { Trip } from '$/models/Trip.model.ts';

const useTripCreate = (refetch = true) => {
  const mutationFn = async (request: Parameters<typeof tripRepository.create>[0]) => {
    return createAction(request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      if (refetch) {
        void queryClient.invalidateQueries({ queryKey: ['trips'] });
      }
    },
  });
};

export default useTripCreate;

async function createAction(request: Parameters<typeof tripRepository.create>[0]): Promise<Trip> {
  const { data, error } = await tripRepository.create(request);

  if (error) throw new Error(error.message);

  return data;
}

